import cn from 'classnames';

/* Styles */
import styles from 'styles/experience-cards.module.scss';

/* Assets */
import thumbsUp from 'assets/images/ThumbsUpBlue.svg';
import thumbsDown from 'assets/images/ThumbsDownBlue.svg';
import thumbsUpFilled from 'assets/images/ThumbsUp_Small_Filled.svg';
import thumbsDownFilled from 'assets/images/ThumbsDown_Small_Filled.svg';

/* Material UI and other UI Dependencies */
import Typography from "@material-ui/core/Typography";
import Box from '@material-ui/core/Box';

const SkillCard =({
  item,
  rating,
  align="center",
  onLikeClick = ()=>{},
  onDislikeClick = ()=>{},
}) => {
  return(
    <div className={styles.card}>
      <Typography variant="h4" align={align} gutterBottom>
        {item.title}
      </Typography>
      <Box className={styles.thumbsContainer} align={align}>
        <span className={cn({[styles.thumbsButton]: true, [styles.thumbsHighlighted]: rating === 'liked'})} onClick={onLikeClick}>
          <img alt="Thumbs Up" src={thumbsUp} className={cn(styles.thumbsImage, styles.outlinedThumbs)} />
          <img alt="Thumbs Up" src={thumbsUpFilled} className={cn(styles.thumbsImage, styles.filledThumbs)} />
        </span>
        <span className={cn({[styles.thumbsButton]: true, [styles.thumbsHighlighted]: rating === 'disliked'})} onClick={onDislikeClick}>
          <img alt="Thumbs Down" src={thumbsDown} className={cn(styles.thumbsImage, styles.outlinedThumbs)} />
          <img alt="Thumbs Down" src={thumbsDownFilled} className={cn(styles.thumbsImage, styles.filledThumbs)} />
        </span>
      </Box>
    </div>
  )
}

export default SkillCard;